export enum KushkiFormIdTypes {
  Card = 'Card',
  BankTransfer = 'BankTransfer',
}
